module.exports = __webpack_public_path__ + "img/industry2_active.4edb22ca.png";